import React from 'react';
import { observer } from 'mobx-react-lite';
import { PortfolioMobxDto } from '../../../../../models/mobx/dtos/portfolio/portfolio-mobx-dto';
import { ValueAmount } from '../../../value/amount/value-amount';
import { AssetIcon } from '../../icon/asset-icon';

type AssetPortfolioSimpleType = {
    data: PortfolioMobxDto;
    disabled?: boolean;
};

export const AssetPortfolioSimple: React.FC<AssetPortfolioSimpleType> = observer(({ data, disabled = false }) => {
    return (
        <div className={`flex flex-1 items-center gap-xsmall ${disabled ? 'opacity-40 blur-[0.2rem]' : ''}`}>
            <AssetIcon type={data.iconName} variant={data.colorName} size={'small'} />
            <div className="flex flex-col gap-[0.2rem]">
                <div className="flex flex-wrap items-center gap-xsmall">
                    <strong className="text-small opacity-80">{data.name}</strong>
                </div>

                <strong className="text-small lg:text-medium">
                    <ValueAmount
                        amount={data.totalValue}
                        currency={data.portfolioHistoryCurrencyCode || data.portfolioHistoryCurrencyCode}
                        mode="pure"
                        locked={disabled}
                        hidable
                    />
                </strong>
            </div>
        </div>
    );
});
